<template>
  <page-header-wrapper>
    <div class="freight-rule-page erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="运费规则名称">
                <a-input v-model="query.ruleName" allow-clear placeholder="请输入" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="区域">
                <region-cascader v-model="query.regionCode" placeholder="全部" />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions">
              <a-button type="primary" icon="search" @click="search">搜索</a-button>
              <a-button icon="redo" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div>
            <h3>运费规则</h3>
            <p>按区域维护订单金额阶梯运费。同一区域可以配置多条运费规则。</p>
          </div>
          <div class="erp-toolbar-actions">
            <a-button icon="sync" :loading="syncing" :disabled="!selectedRowKeys.length" @click="syncSelected">同步数据</a-button>
            <a-button type="primary" icon="plus" @click="openCreate">新增运费规则</a-button>
            <a-button icon="download" :loading="exporting" @click="exportRows">导出</a-button>
          </div>
        </div>
        <a-table
          :row-key="rowKey"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          :row-selection="rowSelection"
          bordered
          size="middle"
          :scroll="{ x: 1100 }"
          @change="onPageChange">
          <template slot="remark" slot-scope="value">{{ value || '无' }}</template>
          <template slot="operation" slot-scope="value, record">
            <a-button size="small" @click="openView(record)">查看</a-button>
            <a-button size="small" @click="openEdit(record)">编辑</a-button>
            <a-button size="small" @click="remove(record)">删除</a-button>
          </template>
        </a-table>
      </div>

      <a-drawer
        :visible="drawerVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer baidao-drawer-sample"
        @close="closeDrawer">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header">
            <div>
              <button class="erp-back-button" type="button" title="返回列表" aria-label="返回列表" @click="closeDrawer">
                <a-icon type="arrow-left" />
              </button>
              <h3>{{ drawerTitle }}</h3>
            </div>
            <div>
              <a-button @click="closeDrawer">取消</a-button>
              <a-button v-if="!readOnly" type="primary" :loading="saving" @click="submit">确定</a-button>
            </div>
          </header>
          <div class="erp-drawer-content">
            <section class="erp-form-card">
              <div class="erp-section-title">
                <span class="erp-section-index">01</span>
                <div><h4>基本信息</h4></div>
              </div>
              <div class="erp-base-grid">
                <label>
                  <span><b class="erp-required">*</b> 运费规则名称</span>
                  <a-input v-model="form.ruleName" :disabled="readOnly" maxlength="128" placeholder="请输入" />
                </label>
                <label class="wide">
                  <span><b class="erp-required">*</b> 区域</span>
                  <region-cascader v-model="form.regionCode" :disabled="readOnly" :fallback-text="form.regionName" />
                </label>
                <label>
                  <span>起送金额</span>
                  <a-input-number
                    v-model="form.minOrderAmount"
                    :disabled="readOnly"
                    :min="0"
                    :precision="2"
                    placeholder="0 表示不设起送门槛"
                    style="width:100%"
                  />
                </label>
                <label class="wide">
                  <span>备注</span>
                  <a-input v-model="form.remark" :disabled="readOnly" maxlength="500" placeholder="请输入" />
                </label>
              </div>
            </section>
            <section class="erp-form-card">
              <div class="erp-section-title">
                <span class="erp-section-index">02</span>
                <div><h4>运费配置</h4></div>
              </div>
              <div class="mode-row">
                <span>计费模式</span>
                <a-input value="订单金额" disabled />
              </div>
              <table class="tier-table">
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>起始数值</th>
                    <th>结束数值</th>
                    <th>计费区间</th>
                    <th>运费金额</th>
                    <th>操作项</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in form.tiers" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <a-input-number v-model="row.startValue" :disabled="readOnly" :min="0" style="width:100%" />
                    </td>
                    <td>
                      <a-input-number v-model="row.endValue" :disabled="readOnly" :min="0" style="width:100%" />
                    </td>
                    <td class="interval">{{ intervalText(row) }}</td>
                    <td>
                      <a-input-number v-model="row.freightAmount" :disabled="readOnly" :min="0" placeholder="请输入" style="width:100%" />
                    </td>
                    <td>
                      <a v-if="!readOnly" class="tier-delete" @click="removeTier(index)">删除</a>
                    </td>
                  </tr>
                  <tr v-if="!form.tiers.length">
                    <td colspan="6" class="tier-empty">请添加阶梯</td>
                  </tr>
                </tbody>
              </table>
              <a-button v-if="!readOnly" class="add-tier" icon="plus" @click="addTier">添加阶梯</a-button>
            </section>
          </div>
        </div>
      </a-drawer>
    </div>
  </page-header-wrapper>
</template>

<script>
import { addFreightRule, deleteFreightRule, editFreightRule, getFreightRule, pageFreightRule, syncFreightRule } from '@/api/erp/freightRule'
import RegionCascader from '../operationRule/RegionCascader.vue'
import { loadChinaArea, regionLabel, regionSubtreeIds } from '../operationRule/regionChina'

function numberValue (value) {
  if (value == null || value === '') return undefined
  const num = Number(value)
  return Number.isFinite(num) ? num : undefined
}

function plainNumber (value) {
  const num = numberValue(value)
  return num == null ? '' : String(num)
}

function blankTier (startValue, endValue) {
  return { startValue, endValue, freightAmount: undefined }
}

function defaultTiers () {
  return [blankTier(1, 10), blankTier(11, 20), blankTier(21, 22)]
}

function blankForm () {
  return {
    id: undefined,
    ruleName: '',
    regionCode: undefined,
    regionName: '',
    minOrderAmount: 0,
    remark: '',
    tiers: defaultTiers()
  }
}

export default {
  name: 'ErpFreightRule',
  components: { RegionCascader },
  data () {
    return {
      loading: false,
      saving: false,
      exporting: false,
      syncing: false,
      readOnly: false,
      drawerVisible: false,
      viewportWidth: window.innerWidth,
      query: { ruleName: '', regionCode: undefined },
      rows: [],
      selectedRowKeys: [],
      form: blankForm(),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        { title: '序号', width: 70, customRender: (text, record, index) => (this.pagination.current - 1) * this.pagination.pageSize + index + 1 },
        { title: '运费规则名称', dataIndex: 'ruleName', width: 180 },
        { title: '区域', dataIndex: 'regionName', width: 220 },
        { title: '计费模式', dataIndex: 'billingModeName', width: 120 },
        { title: '起送金额', dataIndex: 'minOrderAmount', width: 110 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' } },
        { title: '操作项', dataIndex: 'operation', width: 220, scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  computed: {
    drawerWidth () { return this.viewportWidth < 1200 ? '100%' : 1080 },
    drawerTitle () {
      if (this.readOnly) return '查看运费规则模版'
      return this.form.id ? '编辑运费规则模版' : '新增运费规则模版'
    },
    rowSelection () {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: keys => { this.selectedRowKeys = keys.map(key => String(key)) }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    loadChinaArea().catch(() => {})
    this.load()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () { this.viewportWidth = window.innerWidth },
    rowKey (record) { return String(record.id) },
    intervalText (row) {
      const start = plainNumber(row.startValue)
      const end = plainNumber(row.endValue)
      if (!start || !end) return ''
      return `${start}<A≤${end}`
    },
    addTier () {
      const last = this.form.tiers[this.form.tiers.length - 1]
      const start = last && numberValue(last.endValue) != null ? numberValue(last.endValue) + 1 : 1
      this.form.tiers.push(blankTier(start, start + 9))
    },
    removeTier (index) {
      this.form.tiers.splice(index, 1)
    },
    buildQuery (pageNum, pageSize) {
      const regionIds = this.query.regionCode ? regionSubtreeIds(this.query.regionCode) : undefined
      return {
        ruleName: this.query.ruleName,
        regionIds: regionIds && regionIds.length ? regionIds : undefined,
        pageNum: pageNum || this.pagination.current,
        pageSize: pageSize || this.pagination.pageSize
      }
    },
    load () {
      this.loading = true
      pageFreightRule(this.buildQuery()).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = Number(page.total || 0)
        this.selectedRowKeys = []
      }).finally(() => { this.loading = false })
    },
    syncSelected () {
      if (!this.selectedRowKeys.length) return this.$message.warning('请选择要同步的运费规则')
      this.syncing = true
      syncFreightRule(this.selectedRowKeys.slice()).then(() => {
        this.$message.success('已同步')
        this.selectedRowKeys = []
      }).finally(() => { this.syncing = false })
    },
    search () { this.pagination.current = 1; this.load() },
    reset () {
      this.query = { ruleName: '', regionCode: undefined }
      this.search()
    },
    onPageChange (pager) {
      this.pagination.current = pager.current
      this.pagination.pageSize = pager.pageSize
      this.load()
    },
    openCreate () {
      this.form = blankForm()
      this.readOnly = false
      this.drawerVisible = true
    },
    fillForm (record) {
      const regionCode = record.regionId == null ? undefined : String(record.regionId)
      const tiers = (record.tiers || []).map(item => ({
        startValue: numberValue(item.startValue),
        endValue: numberValue(item.endValue),
        freightAmount: numberValue(item.freightAmount)
      }))
      this.form = {
        id: record.id,
        ruleName: record.ruleName || '',
        regionCode,
        regionName: regionLabel(regionCode) || record.regionName || '',
        minOrderAmount: numberValue(record.minOrderAmount) != null ? numberValue(record.minOrderAmount) : 0,
        remark: record.remark || '',
        tiers
      }
    },
    openRecord (record, readOnly) {
      getFreightRule(record.id).then(res => {
        this.fillForm(res.data || record)
        this.readOnly = readOnly
        this.drawerVisible = true
      })
    },
    openView (record) { this.openRecord(record, true) },
    openEdit (record) { this.openRecord(record, false) },
    closeDrawer () { this.drawerVisible = false },
    submit () {
      if (!this.form.ruleName || !this.form.ruleName.trim()) return this.$message.warning('请输入运费规则名称')
      if (!this.form.regionCode) return this.$message.warning('请选择区域')
      if (!this.form.tiers.length) return this.$message.warning('请添加运费阶梯')
      const tiers = []
      for (let i = 0; i < this.form.tiers.length; i++) {
        const row = this.form.tiers[i]
        const startValue = numberValue(row.startValue)
        const endValue = numberValue(row.endValue)
        const freightAmount = numberValue(row.freightAmount)
        if (startValue == null) return this.$message.warning('请输入起始数值')
        if (endValue == null) return this.$message.warning('请输入结束数值')
        if (endValue <= startValue) return this.$message.warning('结束数值必须大于起始数值')
        if (freightAmount == null) return this.$message.warning('请输入运费金额')
        tiers.push({ startValue, endValue, freightAmount })
      }
      const ordered = tiers.slice().sort((a, b) => a.startValue - b.startValue)
      for (let i = 1; i < ordered.length; i++) {
        if (ordered[i].startValue < ordered[i - 1].endValue) return this.$message.warning('运费阶梯区间不能重叠')
      }
      const minOrderAmount = numberValue(this.form.minOrderAmount)
      if (minOrderAmount != null && minOrderAmount < 0) return this.$message.warning('起送金额不能小于0')
      const payload = {
        id: this.form.id,
        ruleName: this.form.ruleName.trim(),
        regionId: String(this.form.regionCode),
        regionName: regionLabel(this.form.regionCode),
        minOrderAmount: minOrderAmount == null ? 0 : minOrderAmount,
        remark: (this.form.remark || '').trim(),
        tiers
      }
      this.saving = true
      const request = payload.id ? editFreightRule(payload) : addFreightRule(payload)
      request.then(() => {
        this.$message.success('已保存')
        this.drawerVisible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    remove (record) {
      this.$confirm({
        title: '确认删除这条运费规则？',
        content: record.ruleName,
        onOk: () => deleteFreightRule(record.id).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      })
    },
    exportRows () {
      this.exporting = true
      pageFreightRule(this.buildQuery(1, 5000)).then(res => {
        const records = (res.data && res.data.records) || []
        const header = ['运费规则名称', '区域', '计费模式', '起送金额', '备注']
        const lines = [header.join(',')]
        records.forEach(row => {
          lines.push([
            row.ruleName,
            row.regionName,
            row.billingModeName || '订单金额',
            plainNumber(row.minOrderAmount) || '0',
            row.remark || '无'
          ].map(value => {
            const text = String(value == null ? '' : value).replace(/"/g, '""')
            return `"${text}"`
          }).join(','))
        })
        const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '运费规则.csv'
        link.click()
        URL.revokeObjectURL(url)
      }).finally(() => { this.exporting = false })
    }
  }
}
</script>

<style scoped>
.freight-rule-page .ant-btn + .ant-btn { margin-left: 8px; }
.freight-rule-page >>> .ant-form-item-control,
.erp-base-grid > label { overflow: visible; }
.mode-row { display: flex; align-items: center; gap: 12px; max-width: 360px; margin-bottom: 16px; }
.mode-row > span { flex: none; color: #526176; font-size: 12px; font-weight: 600; }
.mode-row .ant-input { background: #f5f5f5; }
.tier-table { width: 100%; border-collapse: collapse; background: #fff; }
.tier-table th,
.tier-table td { border: 1px solid #f0f0f0; padding: 8px 10px; text-align: center; }
.tier-table th { background: #fafafa; color: #526176; font-weight: 600; }
.tier-table .interval { color: #667085; background: #fafafa; }
.tier-empty { color: #98a2b3; padding: 18px; }
.tier-delete { color: #ff4d4f; }
.add-tier { margin-top: 12px; }
</style>
